import DOMPurify, { Config } from 'isomorphic-dompurify';

const sanitizeConfig: Config = {
  // разрешение на теги у элементов
  ADD_ATTR: ['target', 'rel'],
  // убираем inline-стили из вставленного контента,
  FORBID_ATTR: ['style'],
};

const sanitizeHtml = (html: string | TrustedHTML): string => {
  if (!html) {
    return '';
  }

  return DOMPurify.sanitize(String(html), sanitizeConfig);
};

export default sanitizeHtml;
